import { useEffect, useState } from "react";
import Header from "./Header";
import { useNavigate, Link, useParams } from "react-router-dom";
import axios from "axios";
import Categories from "./Categories";
import { FaHeart } from "react-icons/fa";
import "./Home.css";
import API_URL from "../constants";

function CategoryPage() {
  const navigate = useNavigate();

  const param = useParams();
  console.log(param);

  const [products, setproducts] = useState([]);
  const [cproducts, setcproducts] = useState([]);
  const [search, setsearch] = useState("");
  const [issearch, setissearch] = useState(false);

  useEffect(() => {
    const url = API_URL + "/get-products?catName=" + param.catName;
    axios
      .get(url)
      .then((res) => {
        if (res.data.products) {
          setproducts(res.data.products);
        }
      })
      .catch((err) => {
        alert("Server Err.");
      });
  }, [param]);

  const handlesearch = (value) => {
    setsearch(value);
  };

  const handleClick = () => {
    const url =
      API_URL +
      "/search?search=" +
      search +
      "&loc=" +
      localStorage.getItem("userLoc");
    axios
      .get(url)
      .then((res) => {
        setcproducts(res.data.products);
        setissearch(true);
      })
      .catch((err) => {
        alert("Server Err.");
      });
  };

  const handleCategory = (value) => {
    let filteredProducts = products.filter((item, index) => {
      if (item.category == value) {
        return item;
      }
    });
    setcproducts(filteredProducts);
  };

  const handleLike = (productId) => {
    let userId = localStorage.getItem("userId");

    const url = API_URL + "/like-product";
    const data = { userId, productId };
    axios
      .post(url, data)
      .then((res) => {
        if (res.data.message) {
          alert("Liked.");
        }
      })
      .catch((err) => {
        alert("Server Err.");
      });
  };

  const handleProduct = (id) => {
    navigate("/product/" + id);
  };

  return (
    <div>
      <Header
        search={search}
        handlesearch={handlesearch}
        handleClick={handleClick}
      />
      <Categories handleCategory={handleCategory} />
      {issearch && cproducts && (
        <h5>
          {" "}
          SEARCH RESULTS
          <button className="clear-btn" onClick={() => setissearch(false)}>
            {" "}
            CLEAR{" "}
          </button>
        </h5>
      )}

      {issearch && cproducts && cproducts.length == 0 && (
        <h5> No Results Found </h5>
      )}
      {issearch && (
        <div className="d-flex justify-content-center flex-wrap">
          {cproducts &&
            products.length > 0 &&
            cproducts.map((item, index) => {
              return (
                <div key={item._id} className="card m-3 ">
                  <div
                    onClick={() => handleLike(item._id)}
                    className="icon-con"
                  >
                    <FaHeart className="icons" />
                  </div>
                  <img
                    width="300px"
                    height="200px"
                    src={API_URL + "/" + item.pimage}
                  />

                  <p className="m-2"> {item.pname} </p>
                  <p className="m-2">{item.category} </p>
                  <h3 className="m-2 text-danger"> {item.price} </h3>
                  <p className="m-2 text-success"> {item.pdesc} </p>
                </div>
              );
            })}
        </div>
      )}

      {!issearch && (
        <div className="d-flex justify-content-center flex-wrap">
          {products &&
            products.length > 0 &&
            products.map((item, index) => {
              return (
                <div
                  onClick={() => handleProduct(item._id)}
                  key={item._id}
                  className="card m-3"
                >
                  <div
                    onClick={() => handleLike(item._id)}
                    className="icon-con"
                  >
                    <FaHeart className="icons" />
                  </div>
                  <img
                    width="250px"
                    height="150px"
                    src={API_URL + "/" + item.pimage}
                  />
                  <h3 className="m-2 price-text"> Rs. {item.price} /- </h3>
                  <p className="m-2"> {item.pname} </p>
                  <p className="m-2">{item.category} </p>
                  <p className="m-2 text-success"> {item.pdesc} </p>
                </div>
              );
            })}
        </div>
      )}
    </div>
  );
}

export default CategoryPage;
